import { ZERO } from '@/constants/common';
import {
  formatsHandlersSelector,
  loadingConfigurationMainSelector,
} from '@/redux/configuration/configuration.selectors';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { useContext, useState } from 'react';
import { CheckboxItem } from '@/components/Map/Drawer/ExportDrawer/CheckboxFilter/CheckboxFilter.types';
import { CheckboxFilter } from '../../CheckboxFilter';
import { CollapsibleSection } from '../../CollapsibleSection';
import { ExportContext } from '../ExportCompound.context';

export const MapFormat = (): React.ReactNode => {
  const { setMapFormats, data } = useContext(ExportContext);
  const currentMapFormats = data.mapFormats;
  const mapHandlers = useAppSelector(formatsHandlersSelector);
  const loadingConfigurationMain = useAppSelector(loadingConfigurationMainSelector);
  const isPending = loadingConfigurationMain === 'pending';

  const mappedElementAnnotations = Object.entries(mapHandlers)
    .filter(([, handler]) => Boolean(handler))
    .map(([name, handler]) => ({
      id: handler,
      label: name,
    }));

  const options = useState<CheckboxItem[]>(mappedElementAnnotations);
  if (
    !isPending &&
    currentMapFormats.length === ZERO &&
    options.length > ZERO &&
    options[ZERO].length > ZERO
  ) {
    setMapFormats([options[ZERO][ZERO]]);
  }

  return (
    <div className={`${data.graphicsMapToggle ? 'visible' : 'hidden'}`}>
      <CollapsibleSection title="Map format" dangerouslySetExpanded>
        {isPending && <p>Loading...</p>}
        {!isPending && mappedElementAnnotations.length > ZERO && (
          <CheckboxFilter
            options={mappedElementAnnotations}
            currentOptions={currentMapFormats}
            onCheckedChange={setMapFormats}
            type="radio"
            isSearchEnabled={false}
          />
        )}
      </CollapsibleSection>
    </div>
  );
};
